import script from "./CustomerLoginAndRegistrationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerLoginAndRegistrationForm.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerLoginAndRegistrationForm.vue?vue&type=style&index=0&id=1148285a&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/packperform.com/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1148285a"]])

export default __exports__